const generateQuery = (pagination, filters, sorter, search) => {
  let query = '';
  if (pagination && Object.keys(pagination).length) {
    query += `&page=${pagination.current}&limit=${pagination.pageSize}`;
  }
  if (sorter && Object.keys(sorter).length && sorter.field) {
    query += `&sort={"${sorter.field}": ${sorter.order === 'ascend' ? '1' : '-1'} }`;
  }
  const fields = Object.keys(filters).filter((key) => filters[key]);
  if (fields.length) {
    const field = Object.keys(filters)[0];
    const value = filters[field] && filters[field][0];
    query += (value) ? `&filter={${search ? `"$or": ${JSON.stringify(search)}, "$and": [{"${field}": ${value}}]` : `"${field}": ${value}`}}` : '';
  } else if (search) {
    query += `&filter={"$or": ${JSON.stringify(search)}}`;
  }
  return query;
};

export const handleSearch = (searchValue, dispatch, action, cols, options = '') => {
  const _searchValue = searchValue.trim().replace(/([^a-zA-Z0-9])/g, '\\$1');
  const columns = Array.isArray(cols) ? cols : cols();
  const searchFields = columns.filter(
    (item) => item.search !== false,
  ).map((row) => ({ index: row.dataIndex, type: (row && row.type) || 'string' }));
  const searchParams = searchFields.map((field) => ({
    [field.index]: field.type === 'number'
      ? Number(_searchValue.trim())
      : { $regex: _searchValue.trim(), $options: 'i' },
  })).filter((item) => !Number.isNaN(item[Object.keys(item)[0]]));

  const search = `filter={"$or": ${JSON.stringify(searchParams)}}`;
  dispatch(action(search, options));

  return searchParams;
};

export default generateQuery;
